/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 广告控制器
 */
import dayjs from 'dayjs';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers/ajaxBasics';
import { BaseModel, BasesController } from '../bases';
@BindAll()
export class ADSController<T = any> extends BasesController<T> {
  constructor() {
    super({
      dataKey: 'id',
      infinite: false,
      pagination: EnumAPI.content_ads,
      paginationParams: {
        defaultCurrent: null,
        defaultPageSize: null,
      },
    });
  }
  /**
   * 值存储
   * @memberof ADSController
   */
  Model = new BaseModel({ type: 'object', storageKey: 'screen_ads' });
  /**
   * 首屏广告图片信息
   */
  @computed
  get firstScreenAds(): any {
    let data = lodash.get(this.Model.value, 'firstScreenAds[0]', {});
    if (!lodash.isEmpty(data)) {
      data.h5PicTime = data.h5PicTime * 1000;
      data.wechatPicTime = data.wechatPicTime * 1000;
    }
    return data;
  }
  /**
   * 第一次访问时间
   */
  @computed
  get firstDate(): number {
    return lodash.get(this.Model.value, 'firstDate', null);
  }
  /**
   * 是否展示首屏广告
   */
  @computed
  get showFirstScreenAds(): boolean {
    return lodash.get(this.Model.value, 'showFirstScreenAds', false);
  }
  /**
   * 获取 首页弹屏信息
   */
  async getScreenAds() {
    try {
      // 等待持久化初始完成
      await this.Model.HydrateAsync;
      const { firstDate } = this;
      // 已经存在时间，并且是当天 跳过
      if (firstDate && dayjs().diff(dayjs(firstDate), 'day') === 0) {
        return;
      }
      let firstScreenAds = await AjaxBasics.request<any>({
        ...EnumAPI.content_screen_ads,
        body: {},
      });

      firstScreenAds = lodash.filter(firstScreenAds, (item) => {
        return item.online == true && item.type == 1; // 首页弹屏类型
      });

      if (lodash.isEmpty(firstScreenAds)) {
        return;
      }

      // 接口返回数据结构变更
      lodash.forEach(firstScreenAds, (screen) => {
        const screenConfigList = lodash.get(screen, 'screenConfigList') || [];

        lodash.forEach(screenConfigList, (item) => {
          const prefix = lodash.get(
            {
              mobile: 'h5',
              wechat: 'wechat',
              desktop: 'pc',
            },
            item.platform,
          );

          screen = lodash.assign(screen, {
            [`${prefix}PicUrl`]: item.picUrl,
            [`${prefix}PicTime`]: item.picTime,
            [`${prefix}ActivityUrl`]: item.activityUrl,
          });
        });
      });

      this.Model.merge({
        firstScreenAds,
        // 记录时间
        firstDate: Date.now(),
        showFirstScreenAds: true,
      });
    } catch (error) {}
  }
  /**
   * 隐藏弹框
   * @memberof ADSController
   */
  onHideScreenAds() {
    this.Model.merge({ showFirstScreenAds: false });
  }
  /**
   * 获取广告
   * @param body
   * @returns
   */
  getAds(sign) {
    return AjaxBasics.request<Array<any>>({
      ...EnumAPI.content_ads,
      body: { sign },
    });
  }
  /**
   * 清除时间戳
   * @memberof ADSController
   */
  onClear() {
    this.Model.set({});
  }
}
